export const messages = {
  en: {
    storeIntegral: {
      title: 'Merchant Points',
      queryCondition: 'Query Conditions',
      placeholder: {
        integralName: 'Please enter account name'
      },
      table: {
        id: 'ID',
        accountName: 'Account Name',
        objectType: 'Object Type',
        objectId: 'Object ID',
        phone: 'Phone',
        points: 'Points'
      },
      merchant: 'Merchant',
      user: 'User',
      give: 'Give',
      deduct: 'Deduct'
    },
    editIntegral: {
      givePoints: 'Give Points',
      deductPoints: 'Deduct Points',
      pointsAccount: 'Points Account',
      remainingPoints: 'Remaining Points',
      giveAmount: 'Give Amount',
      deductAmount: 'Deduct Amount',
      requiredAmount: 'Required, please enter amount',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remarks',
      amountRequired: 'Amount is required'
    },
    deleteIntegral: {
      confirmOperation: 'Please confirm your operation',
      confirmDeletePointsAccount: 'Confirm to delete points account',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete'
    }
  },
  zh: {
    storeIntegral: {
      title: '商户积分',
      queryCondition: '查询条件',
      placeholder: {
        integralName: '请输入账户名称'
      },
      table: {
        id: '编号',
        accountName: '账户名称',
        objectType: '对象类型',
        objectId: '对象ID',
        phone: '手机号',
        points: '积分数'
      },
      merchant: '商户',
      user: '用户',
      give: '赠送',
      deduct: '扣减'
    },
    editIntegral: {
      givePoints: '赠送积分',
      deductPoints: '扣减积分',
      pointsAccount: '积分账户',
      remainingPoints: '剩余积分',
      giveAmount: '赠送数量',
      deductAmount: '扣减数量',
      requiredAmount: '必填，请填写数量',
      remark: '说明',
      remarkPlaceholder: '请填写说明',
      amountRequired: '数量不能为空'
    },
    deleteIntegral: {
      confirmOperation: '请确认您的操作',
      confirmDeletePointsAccount: '确定删除积分账户',
      cancel: '点错了',
      confirmDelete: '确认删除'
    }
  }
}